<template>
  <div :class="$style.warningMessageArea">
    <div :class="$style.warningMessageIconArea">
      <svg viewBox="0 0 12 11" fill="none" xmlns="http://www.w3.org/2000/svg" :class="$style.warningMessageIcon" v-bind:svg-inline="''" v-bind:role="'presentation'" v-bind:focusable="'false'" v-bind:tabindex="'-1'"><path fill-rule="evenodd" clip-rule="evenodd" d="M6.75 5.147L6.39 7.44h-.78l-.36-2.294V3.75h1.5v1.397zM6.695 9H5.304V7.86h1.391V9zm5.223.586L6.53.305a.614.614 0 00-1.062 0L.082 9.585a.608.608 0 00.53.915h10.775a.608.608 0 00.53-.914z" fill="#FF7D00"/></svg>
    </div>

    <IconButton
      v-if="isDismissable"
      :class="$style.warningMessageDismissButton"
      @click="dismiss"
    >
      <svg viewBox="0 0 45 45" xmlns="http://www.w3.org/2000/svg" v-bind:svg-inline="''" v-bind:role="'presentation'" v-bind:focusable="'false'" v-bind:tabindex="'-1'"><g transform="translate(0 .5)" fill="none" fill-rule="evenodd"><ellipse cx="22.5" cy="22" rx="22.5" ry="22"/><path d="M31 14.5l-16 15m0-15l16 15" stroke="currentColor" stroke-width="2"/></g></svg>
    </IconButton>

    <div :class="$style.warningMessageContent">
      <div
        v-if="title"
        :class="$style.warningMessageTitle"
      >
        {{ title }}
      </div>

      <div :class="$style.warningMessageBody">
        <slot />
      </div>
    </div>
  </div>
</template>

<script>
import IconButton from 'client/components/Buttons/IconButton.vue';

export default {
  name: 'Warning',

  components: {
    IconButton,
  },

  props: {
    isDismissable: {
      type: Boolean,
      default: false,
    },
    title: {
      type: String,
      required: false,
      default: '',
    },
  },

  methods: {
    dismiss() {
      this.$emit('dismiss');
    },
  },
};
</script>

<style module>
.warningMessageArea {
  background: var(--jcWarning100);
  border: 1px solid var(--jcWarning900);
  display: flex;
  padding: 0.25em;
  position: relative;
}

.warningMessageIconArea {
  padding: 0.65em 0.75em 0.5em 0.5em;
}

.warningMessageIcon {
  align-self: baseline;
  font-size: 1em;
  height: auto;
  width: 1.1em;
}

.warningMessageDismissButton {
  cursor: pointer;
  position: absolute;
  right: 0.5rem;
}

.warningMessageContent {
  padding: 0.5em;
  padding-left: 0;
}

.warningMessageTitle {
  color: var(--jcGrey900);
  font-size: 0.9em;
  margin-bottom: 0.5em;
}

.warningMessageBody {
  color: var(--jcGrey900);
  margin-right: 1.25rem;
}
</style>
